/**
 * @generated SignedSource<<6ab519d714ef59dac2f381b0990d870f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly created: any;
      readonly createdBy: {
        readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
      };
      readonly description: string | null;
      readonly id: string;
      readonly isActive: boolean;
      readonly period: number | null;
      readonly sequence: number;
      readonly startAt: any;
      readonly template: {
        readonly templateCode: string;
        readonly templateName: string;
      };
      readonly title: string;
    };
  }>;
  readonly " $fragmentType": "BrandMessageTaskConnectionDataTable_brandMessageTaskConnection";
};
export type BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$key = {
  readonly " $data"?: BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTaskConnectionDataTable_brandMessageTaskConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageTaskConnectionDataTable_brandMessageTaskConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageTaskEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandMessageTask",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserAvatarText_user"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BrandMessageTemplate",
              "kind": "LinkedField",
              "name": "template",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "period",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessageTaskConnection",
  "abstractKey": null
};

(node as any).hash = "b111140f9a37f12ec2b62bdc14a0e60a";

export default node;
